import * as ee from 'eventemitter3';
// @ts-expect-error this is because eventemitter3 is a CommonJS module
const eventemitter = (ee.default || ee);
const events = new eventemitter.EventEmitter();
function on(eventId, fn, context) {
    events.addListener(eventId, fn, context);
    return () => {
        events.removeListener(eventId, fn, context);
    };
}
function once(eventId, fn, context) {
    events.once(eventId, fn);
    return () => {
        events.removeListener(eventId, fn, context);
    };
}
function emit(eventId, ...args) {
    events.emit(eventId, ...args);
}
function removeAllListeners(eventId) {
    events.removeAllListeners(eventId);
}
export const event = {
    on,
    once,
    emit,
    removeAllListeners,
};
//# sourceMappingURL=event.js.map